import { useContext, useEffect } from "react";
import { wsGetTextosCheckIn } from "./context/action/textosAutoCheckin";
import { AutocheckContext } from "./context/Provider";

const GlobalInitializeDataCheckIn = ({children}) => { 
    const {
        textosAutoCheckinDispatch
    } = useContext(AutocheckContext); 

    // Aca llamo los textos del checkin
    useEffect(() => {
        wsGetTextosCheckIn()(textosAutoCheckinDispatch);
    }, []); 
     
    return (
        <>
            {
                children
            }
        </>
    )
}

export default GlobalInitializeDataCheckIn; 
